import { Link } from "gatsby"
import React from "react"
import { createBfzArticleTeaserLink } from "components/page-components/Teaser-Cards/utils"

export const MostReadArticlesVertical = ({ most_read_articles, ressort }) => {
  return (
    <div data-nosnippet className="py-4 my-3 most-read-wrapper pl-2">
      <p className="has-text-weight-bold mb-4 mt-0 has-text-mitternachtsblau">
        Meistgelesene Artikel
      </p>
      <div className="most-read-articles no-scrollbar">
        {most_read_articles?.map((article, index) => {
          const article_link = createBfzArticleTeaserLink(article, ressort)
          return (
            <div key={`most_read-${index}`} className="columns is-mobile">
              <div className="column is-1 pl-0 my-auto">
                <p className="title is-2 mb-0 has-text-mitternachtsblau-30">
                  {index + 1}
                </p>
              </div>
              <div className="column pr-2">
                <Link to={article_link}>
                  <p
                    className={`has-text-${article.ressort} mb-0 is-clipped`}
                    style={{
                      minHeight: "1.75rem",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {article.kicker}
                  </p>

                  <p
                    className={`has-text-weight-bold has-text-mitternachtsblau mb-3`}
                  >
                    {article.headline}
                  </p>
                </Link>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
